import history from "./history";

const forwardTo = (location) => history.getHistory().push(location);

const goBack = () => history.getHistory().goBack();

const reload = () => window.location.reload();

const replace = (location) => history.getHistory().replace(location);

const redirect = (location) => {
  window.location.href = location;
};

const navigationService = {
  forwardTo,
  goBack,
  redirect,
  reload,
  replace
};

export default navigationService;
